export const getWorkorderStatusId = (workOrderStatus: string): number => {
  const statusMap: Record<string, number> = {
    Draft: 1,
    Published: 2,
    Assigned: 3,
    'Work Done': 4,
    Approved: 5,
    Paid: 6,
    Cancelled: 7,
    Postponed: 8,
    Routed: 9,
    Deleted: 10,
  };

  return statusMap[workOrderStatus] || 0;
};
